const MAX_SUMMARY_LENGTH = 120;

/**
 * Versão curta de um erro de indexação, para caber em uma linha da tabela.
 *
 * O erro que o worker grava costuma ser um stack trace ou uma mensagem longa de
 * biblioteca, com caminho de arquivo e detalhe interno. Mostrar isso inteiro na
 * lista estourava a largura da tabela e não dizia nada a quem só quer saber que
 * o arquivo falhou. O texto integral continua disponível no painel de detalhes.
 */
export function summarizeError(message: string, maxLength = MAX_SUMMARY_LENGTH): string {
  const firstLine = message.trim().split('\n')[0]?.trim() ?? '';
  if (firstLine.length <= maxLength) return firstLine;
  return `${firstLine.slice(0, maxLength - 1).trimEnd()}…`;
}
